module.exports = __webpack_public_path__ + "img/fantastic-four.64fa7ea8.svg";